import { render } from "./PrimaryLayout.vue?vue&type=template&id=53a07f3a&scoped=true"
import script from "./PrimaryLayout.vue?vue&type=script&lang=js"
export * from "./PrimaryLayout.vue?vue&type=script&lang=js"

import "./PrimaryLayout.vue?vue&type=style&index=0&id=53a07f3a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53a07f3a"

export default script